<template>
    <PageWrapper>
        <template #headline>
            <fa icon="cart-shopping" />
            {{ $t('orders') }}
        </template>

        <OrdersTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@partials/pages/PageWrapper.vue'
import OrdersTable from '@partials/orders/OrdersTable.vue'
</script>
